/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import React from 'react';
import { Cloudinary } from 'cloudinary-core';

const cl = new Cloudinary({ cloud_name: 'bottlebooks', secure: true });

type UrlOptions = Parameters<typeof cl.url>[1];

interface Props {
  publicId: string;
  cloudName?: string;
  layout?: 'fixed' | 'constrained' | 'fullWidth';
  width?: number;
  height?: number;
  alt?: string;
  sizes?: string;
  options?: UrlOptions;
}

export default function Image({
  publicId,
  cloudName = 'bottlebooks',
  layout,
  width,
  height,
  alt,
  sizes,
  options,
  ...rest
}: Props) {
  if (!publicId) return null;
  if (layout === 'fixed')
    return (
      <img
        width={width}
        height={height}
        alt={alt}
        src={cl.url(publicId, {
          fetch_format: 'png',
          ...options,
          width,
          height,
        })}
        sizes={sizes}
        {...rest}
      />
    );

  return null;
}
